import type { IndustryOption } from "../api/opportunity-sets.api";

/**
 * True when the sync found no competitor ad library URL for the platform in this industry.
 * An industry that was never synced (`null`) stays available, and so does any industry
 * while no platform is picked.
 */
export function isIndustryMissingPlatform(
  industry: Pick<IndustryOption, "competitorAdPlatforms">,
  platformId: string | null | undefined,
): boolean {
  if (!platformId || industry.competitorAdPlatforms == null) return false;
  return !industry.competitorAdPlatforms.includes(platformId);
}

/** Moves disabled industries after the selectable ones; each group keeps its incoming order. */
export function sortDisabledIndustriesLast<T>(industries: readonly T[], isDisabled: (industry: T) => boolean): T[] {
  return [...industries.filter((industry) => !isDisabled(industry)), ...industries.filter(isDisabled)];
}
